import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

import type { SmartLinkType } from './index';

const UNKNOWN = 'unknown';
// API maximum batch count is 50
const MIN_BATCH_COUNT = 5;
const DEFAULT_BATCH_COUNT = 50;

export function isFirstParty(link: string): boolean {
	// Reference: https://bitbucket.org/atlassian/integrations-service/src/master/src/main/resources/integrations/
	return (
		// jira
		link.includes('/jira/') ||
		link.includes('/servicedesk/') ||
		link.includes('/helpcenter/') ||
		link.includes('/projects/') ||
		link.includes('/browse/') ||
		// confluence
		link.includes('/wiki/') ||
		// other general atlassian domains
		link.includes('atlassian') ||
		link.includes('bitbucket') ||
		link.includes('jira-dev')
	);
}

export function groupSmartLinksByHostname(smartLinks: SmartLinkType[]): SmartLinkType[][] {
	return Object.values(
		smartLinks.reduce(
			(acc, smartLink) => {
				try {
					const hostname = new URL(smartLink.resourceUrl).hostname;
					(acc[hostname] ||= []).push(smartLink);
				} catch (e) {
					(acc[UNKNOWN] ||= []).push(smartLink);
				}
				return acc;
			},
			{} as Record<string, SmartLinkType[]>,
		),
	);
}

export function splitLinksIntoBatches(smartLinksGroups: SmartLinkType[][]): SmartLinkType[][] {
	const max = Math.max(
		MIN_BATCH_COUNT,
		StatsigConfigurations.getNumber(
			'confluence_ssr_content_smart_link_max_batch_count',
			DEFAULT_BATCH_COUNT,
		),
	);

	const result: SmartLinkType[][] = [];
	for (const smartLinks of smartLinksGroups) {
		if (smartLinks.length <= max) {
			result.push(smartLinks);
		} else {
			for (let i = 0; i < smartLinks.length; i += max) {
				result.push(smartLinks.slice(i, i + max));
			}
		}
	}
	return result;
}

export function mergeSmallThirdPartyBatches(
	smartLinksGroups: SmartLinkType[][],
): SmartLinkType[][] {
	const result: SmartLinkType[][] = [];
	const smallThirdPartyBatches: SmartLinkType[] = [];
	for (const smartLinks of smartLinksGroups) {
		if (smartLinks.length >= MIN_BATCH_COUNT || isFirstParty(smartLinks[0].resourceUrl)) {
			result.push(smartLinks);
		} else {
			smallThirdPartyBatches.push(...smartLinks);
		}
	}
	if (smallThirdPartyBatches.length > 0) {
		result.push(smallThirdPartyBatches);
	}
	return result;
}
